import { useEffect,useState } from 'react';
import { DataGrid, GridRowsProp, GridColDef, GridToolbarContainer,
  GridToolbarColumnsButton,GridToolbarExport,esES} from '@mui/x-data-grid';
import {cellWrapText, WrapperResult} from './styles';
import {useDispatch, useSelector} from "react-redux";
import {ExportToExcel} from "../export_report/Export";
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import {CustomCellRenderer} from "./renderCellExpand"
import TicketModal from "./modal";


const columns: GridColDef[] = [
  { field: 'ticketId', headerClassName: 'super-app-theme--header', headerName: 'Id', width: 150 },
  { field: 'sitioId', headerClassName: 'super-app-theme--header', headerName: 'Sitio', width: 150 },
  { field: 'numreportesoc', headerClassName: 'super-app-theme--header', headerName: 'Reporte SOC', width: 150 },
  { field: 'numreportebestel', headerClassName: 'super-app-theme--header', headerName: 'Reportes Bestel', width: 150 },
  { field: 'numreportecliente', headerClassName: 'super-app-theme--header', headerName: 'Reporte Cliente', width: 150, hide: true },
  { field: 'fcInicioTicket',headerClassName: 'super-app-theme--header', headerName: 'Fecha Inicio', width: 150 },
  { field: 'fcFinticket', headerClassName: 'super-app-theme--header', headerName: 'Fecha Fin', width: 150 },
  { field: 'dsticketstatus', headerClassName: 'super-app-theme--header', headerName: 'Estatus', width: 150 },
  { field: 'dstipofalla', headerClassName: 'super-app-theme--header', headerName: 'Tipo Falla', width: 150},
  { field: 'dsrequerimiento', headerClassName: 'super-app-theme--header', headerName: 'Tipo Requerimiento', width: 150, hide: true },
  { field: 'dscriticidad', headerClassName: 'super-app-theme--header', headerName: 'Criticidad', width: 150 },
  { field: 'dstickettipo', headerClassName: 'super-app-theme--header', headerName: 'Tipo Ticket', width: 150 , hide: true},
  { field: 'casoid', headerClassName: 'super-app-theme--header', headerName: 'Caso Id', width: 150 , hide: true},
  { field: 'usuarioreporta', headerClassName: 'super-app-theme--header', headerName: 'Usuario que Reporta', width: 150 , hide: true},
  { field: 'usuariocargo', headerClassName: 'super-app-theme--header', headerName: 'Usuario a Cargo', width: 150, hide: true },
  { field: 'refenlace', headerClassName: 'super-app-theme--header', headerName: 'Enlace', width: 150 , hide: true},
  { field: 'responsable', headerClassName: 'super-app-theme--header', headerName: 'Responsable', width: 150, renderCell: (params) => (
      <div style={{ whiteSpace: 'normal' }}>{params.value}</div>
    ), hide: true},
  { field: 'ingasignado', headerClassName: 'super-app-theme--header', headerName: 'Ingeniero Asignado', width: 150, cellClassName: cellWrapText,
    renderCell: (params) => (
      <div style={{ whiteSpace: 'normal' }}>{params.value}</div>
    ), hide: true},
  { field: 'detalle', headerClassName: 'super-app-theme--header', headerName: 'Detalle Ticket', width: 500,  renderCell: (params) =>  (
      <CustomCellRenderer
        value={params.value}
        field={params.field}
        cellClassName={params.cellClassName}
      />
    ), hide: true},
  { field: 'actividad', headerClassName: 'super-app-theme--header', headerName: 'Actividad', width: 500,  renderCell: (params) =>  (
      <CustomCellRenderer
        value={params.value}
        field={params.field}
        cellClassName={params.cellClassName}
      />
    ), hide: true},
  { field: 'descripcion', headerClassName: 'super-app-theme--header', headerName: 'Descripción', width: 200, hide: true},
  { field: 'severidad', headerClassName: 'super-app-theme--header', headerName: 'Severidad', width: 200 , hide: true},
  { field: 'boafectacion', headerClassName: 'super-app-theme--header', headerName: 'Tuvo Afectación', width: 200,  renderCell: (params) => {return params.value == "t" ? "Sí":"No" }, hide: true},
  { field: 'boatribuible', headerClassName: 'super-app-theme--header', headerName: 'Afectación Atribuible a Bestel', width: 200 ,  renderCell: (params) => {return params.value == "t" ? "Sí":"No" }, hide: true}
];

// let tickets: GridRowsProp = []


const ResultSearch = ({ filters, actualizarFiltros, initTickets}) => {
  const [openModal, setOpenModal] = useState(false);
  const tickets = useSelector((state) => state.fuse?.reportesTickets?.tickets ? 
    state.fuse?.reportesTickets?.tickets.map((ticket, index) => ({
      id: index,
      ...ticket, 
    })) : []);
  const loading = useSelector((state) => state.fuse?.reportesTickets?.loading)
  

  const [ticketSel,setTicketSel] = useState({})

  const handlerClose = () => setOpenModal(false);
  
  const handleRowClick = (e)=>{
    console.log(e)
    e.row.boafectacion == "t" ? e.row.boafectacion ="Sí" : e.row.boafectacion= "No"
    e.row.boatribuible == "t" ?  e.row.boatribuible ="Sí" : e.row.boatribuible ="No"
    setTicketSel(e)
    setOpenModal(true);
  }

  useEffect(() => {
    initTickets()
  }, [filters])

  
  return (
    <WrapperResult>
      <strong> Resultados de la Búsqueda</strong>
        <div style={{ height: '100%', width: '100%' }}>
          <DataGrid
            rows={tickets}
            columns={columns}
            onRowClick={handleRowClick}
            components={{
              Toolbar:() => (
                <GridToolbarContainer>
                  <GridToolbarColumnsButton />
                  <IconButton  onClick={() => ExportToExcel(tickets,columns)}>
                  <DownloadIcon/>
                  </IconButton>
                  Exportar a Excel
                </GridToolbarContainer>
              ),
            }}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            wrapText
            autoHeight
            sx={{ '--DataGrid-overlayHeight': '300px',
              height: 450,
              width: '100%',
              boxShadow: 2,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
              '& .MuiDataGrid-row:hover': {
                background: '#01A9DB',
                cursor: 'pointer',
              },
              '& .super-app-theme--header': {
              backgroundColor: '#5E75F2',
              color: 'white',
            },
            }}
            loading={loading}
          />
        </div>
      <TicketModal openModal={openModal} handlerClose={handlerClose} ticketSel={ticketSel} />
    </WrapperResult>
  );
};

export default ResultSearch;
